import { c as _c } from "react/compiler-runtime";
import { Button, Spinner, Table } from '@chakra-ui/react';
import { MemberSearchFilters } from '@src/components/sco/Members/MemberSearchResults';
import { MembersTableRow } from '@src/components/sco/Members/MembersTable/MembersTableRow';
import { PaywalledAction } from '@src/components/sco/PaywalledAction';
import { ScoUser, ScoUserCollection } from '@src/graphql-types';
import { QueryStateSet } from '@src/hooks/useQueryStateSet';
import React from 'react';
type MembersTableProps = {
  onLoadMore?: () => void;
  filters?: QueryStateSet<MemberSearchFilters>;
  loading?: boolean;
  members?: ScoUser[];
  membersCollection?: ScoUserCollection;
};
export const MembersTable = props => {
  const $ = _c(17);
  let t0;
  if ($[0] !== props.members || $[1] !== props.membersCollection?.items) {
    t0 = props.members || props.membersCollection?.items || [];
    $[0] = props.members;
    $[1] = props.membersCollection?.items;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const members = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Table.Header borderTop="1px solid" borderTopColor="whiteAlpha.300"><Table.Row><Table.ColumnHeader>Founder</Table.ColumnHeader><Table.ColumnHeader>Company</Table.ColumnHeader><Table.ColumnHeader>Industry</Table.ColumnHeader><Table.ColumnHeader>Stage</Table.ColumnHeader><Table.ColumnHeader>Location</Table.ColumnHeader></Table.Row></Table.Header>;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== members) {
    t2 = members.map(_temp);
    $[4] = members;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <Table.Body>{t2}</Table.Body>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props.loading || $[9] !== props.membersCollection?.pagination?.hasNextPage || $[10] !== props.onLoadMore) {
    t4 = props.onLoadMore && props.membersCollection?.pagination?.hasNextPage && <PaywalledAction contentPermission="canAccessFGMemberDirectory" intent="member-directory" title="Become a Community Member to view the full Founder Directory." variant="boxed"><Button disabled={props.loading} variant="outline" onClick={props.onLoadMore}>{props.loading ? <Spinner /> : "Load More"}</Button></PaywalledAction>;
    $[8] = props.loading;
    $[9] = props.membersCollection?.pagination?.hasNextPage;
    $[10] = props.onLoadMore;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = <Table.Footer><Table.Row><Table.Cell colSpan={100} textAlign="center">{t4}</Table.Cell></Table.Row></Table.Footer>;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t3 || $[15] !== t5) {
    t6 = <Table.ScrollArea><Table.Root>{t1}{t3}{t5}</Table.Root></Table.ScrollArea>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
MembersTable.fragments = {
  ScoUser: MembersTableRow.fragments.ScoUser
};
function _temp(member) {
  return <MembersTableRow key={member.id} member={member} />;
}